import { render, staticRenderFns } from "./BCPagination.vue?vue&type=template&id=43d51995&"
import script from "./BCPagination.vue?vue&type=script&lang=js&"
export * from "./BCPagination.vue?vue&type=script&lang=js&"
import style0 from "./BCPagination.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports